"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation UpdateOutput($outputId: String!, $input: UpdateOutputInput!) {\n    updateOutput(outputId: $outputId, input: $input) {\n      outputId\n        videoId\n        readableId\n        status {\n          name\n        }\n        aspectRatio\n        isMaster\n        name\n        description\n        tags\n        latestVersion\n        versions {\n          versionNumber\n          dueDate\n          versionId\n          assetId\n        }\n        video {\n          organisationId\n          videoProjectId\n          name\n          creator {\n            userId\n            firstName\n            lastName\n            imageUrl\n          }\n        }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var updateOutputQuery = (0, _graphqlTag.default)(_templateObject());
var updateOutput = {
  mutation: updateOutputQuery,
  module: 'video',
  buildVariables: function buildVariables(_ref) {
    var outputId = _ref.outputId,
        inputVars = _objectWithoutProperties(_ref, ["outputId"]);

    return {
      outputId: outputId,
      input: inputVars
    };
  }
};
var _default = updateOutput;
exports.default = _default;